/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    nextUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    di?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    vc?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    dj?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    transactionId?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    benefitStationTmpReserveNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyInvestPrice?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    sessionInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyName1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyInvestPrice1?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyName2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyInvestPrice2?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyName3?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyInvestPrice3?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyName4?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyInvestPrice4?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyName5?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    subsidyInvestPrice5?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse
     */
    dn?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponseFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse {
    return JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponseFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextUrl': !exists(json, 'nextUrl') ? undefined : json['nextUrl'],
        'di': !exists(json, 'di') ? undefined : json['di'],
        'vc': !exists(json, 'vc') ? undefined : json['vc'],
        'dj': !exists(json, 'dj') ? undefined : json['dj'],
        'transactionId': !exists(json, 'TransactionId') ? undefined : json['TransactionId'],
        'benefitStationTmpReserveNo': !exists(json, 'Benefit_StationTmpReserveNo') ? undefined : json['Benefit_StationTmpReserveNo'],
        'subsidyInvestPrice': !exists(json, 'SubsidyInvestPrice') ? undefined : json['SubsidyInvestPrice'],
        'sessionInfo': !exists(json, 'SessionInfo') ? undefined : json['SessionInfo'],
        'subsidyName1': !exists(json, 'SubsidyName1') ? undefined : json['SubsidyName1'],
        'subsidyInvestPrice1': !exists(json, 'SubsidyInvestPrice1') ? undefined : json['SubsidyInvestPrice1'],
        'subsidyName2': !exists(json, 'SubsidyName2') ? undefined : json['SubsidyName2'],
        'subsidyInvestPrice2': !exists(json, 'SubsidyInvestPrice2') ? undefined : json['SubsidyInvestPrice2'],
        'subsidyName3': !exists(json, 'SubsidyName3') ? undefined : json['SubsidyName3'],
        'subsidyInvestPrice3': !exists(json, 'SubsidyInvestPrice3') ? undefined : json['SubsidyInvestPrice3'],
        'subsidyName4': !exists(json, 'SubsidyName4') ? undefined : json['SubsidyName4'],
        'subsidyInvestPrice4': !exists(json, 'SubsidyInvestPrice4') ? undefined : json['SubsidyInvestPrice4'],
        'subsidyName5': !exists(json, 'SubsidyName5') ? undefined : json['SubsidyName5'],
        'subsidyInvestPrice5': !exists(json, 'SubsidyInvestPrice5') ? undefined : json['SubsidyInvestPrice5'],
        'dn': !exists(json, 'dn') ? undefined : json['dn'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponseToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseJalConfirmPostResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextUrl': value.nextUrl,
        'di': value.di,
        'vc': value.vc,
        'dj': value.dj,
        'TransactionId': value.transactionId,
        'Benefit_StationTmpReserveNo': value.benefitStationTmpReserveNo,
        'SubsidyInvestPrice': value.subsidyInvestPrice,
        'SessionInfo': value.sessionInfo,
        'SubsidyName1': value.subsidyName1,
        'SubsidyInvestPrice1': value.subsidyInvestPrice1,
        'SubsidyName2': value.subsidyName2,
        'SubsidyInvestPrice2': value.subsidyInvestPrice2,
        'SubsidyName3': value.subsidyName3,
        'SubsidyInvestPrice3': value.subsidyInvestPrice3,
        'SubsidyName4': value.subsidyName4,
        'SubsidyInvestPrice4': value.subsidyInvestPrice4,
        'SubsidyName5': value.subsidyName5,
        'SubsidyInvestPrice5': value.subsidyInvestPrice5,
        'dn': value.dn,
    };
}

